import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import TableWrapper from '@/components/table/TableWrapper';
import NoRowsWrapper from '@/components/table/NoRowsWrapper';
import Dialog from '@/components/dialogs/Dialog';
import { hideDatasetConditions } from '../actions';
import DatasetConditionRows from '../components/DatasetConditionRows';
import DatasetConditionsTableColumns, {
  useDatasetConditionsTableColumns,
} from '../components/DatasetConditionsTableColumns';
import { isWorkspaceCondition } from '../helper';

const DatasetConditionsDialog = ({
  code,
  datasetConditions,
  hide,
  name,
  readErrors,
  readStatus,
  theme,
}) => {
  const isSmallWizard = datasetConditions?.some(({ condition }) => !isWorkspaceCondition(condition));
  const columns = useDatasetConditionsTableColumns(datasetConditions);

  return (
    <Dialog
      className={clsx('aridhia-dataset-conditions-dialog', isSmallWizard ? 'smallwizard' : 'tinywizard')}
      loading={readStatus === states.PENDING}
      messageIcon="clipboard list"
      message="dataset.conditions.info"
      onClose={hide}
      size="small"
      theme={theme}
      title={name}
    >
      <NoRowsWrapper
        className="min-h-100p"
        entity="dataset.condition"
        items={datasetConditions}
        readStatus={[readStatus]}
        readErrors={readErrors}
      >
        <div className="aridhia-dataset-conditions-dialog-table">
          <TableWrapper sticky celled className="aridhia-datasets-table">
            <Table.Header fullWidth>
              <DatasetConditionsTableColumns columns={columns} />
            </Table.Header>
            <Table.Body>
              <DatasetConditionRows code={code} columns={columns} datasetConditions={datasetConditions} />
            </Table.Body>
          </TableWrapper>
        </div>
      </NoRowsWrapper>
    </Dialog>
  );
};

const mapStateToProps = ({
  datasetConditions: {
    activeConditions: {
      code, items, name, readErrors, readStatus,
    },
  },
}) => ({
  code,
  datasetConditions: items,
  name,
  readErrors,
  readStatus,
});

const mapDispatchToProps = {
  hide: hideDatasetConditions,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetConditionsDialog);
